import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../../../../../../core/animations';

// Service file

import { SideNavService } from '../../../../../../../sidenav.service';

/**Local file */

import { userInfo } from '../../../../../../../../../../utils/index';

@Component({
    selector: 'pro-reference',
    templateUrl: './proReference.component.html',
    styleUrls: ['./proReference.component.scss'],
    animations: fuseAnimations
})

export class ProReferenceComponent {

    userInfo = userInfo;

    refLoading: boolean = false;
    perLoading: boolean = false;

    userId: string = "";

    qualityRef = [];
    personalityRef = [];

    displayedColumns = ['name', 'email', 'phone'];

    refDataSource: MatTableDataSource<referenceData>;
    @ViewChild('refPaginator') refPaginator: MatPaginator;
    @ViewChild(MatSort) refSort: MatSort;

    perDataSource: MatTableDataSource<referenceData>;
    @ViewChild('perPaginator') perPaginator: MatPaginator;
    @ViewChild(MatSort) perSort: MatSort;

    onProUserInfoTabSelectedSubscription: Subscription;

    constructor(

        public sideNavService: SideNavService
    ) {

    }
    ngOnInit() {

        this.onProUserInfoTabSelectedSubscription =
            this.sideNavService.onProUserInfoTabSelected.subscribe(selected => {

                this.userId = selected.userId;
                this.fetchAllQualityReferences();
                this.fetchAllPerReferences();
            })

    }


    /**
     * Set the paginator after the view init since this component will
     * be able to query its view for the initialized paginator.
     */
    ngAfterViewInit() {

        if (this.perDataSource) {
            this.perDataSource.paginator = this.perPaginator;
            this.perDataSource.sort = this.perSort;
        }

        if (this.refDataSource) {
            this.refDataSource.paginator = this.refPaginator;
            this.refDataSource.sort = this.refSort;
        }

    }

    ngOnDestroy() {
        this.onProUserInfoTabSelectedSubscription.unsubscribe();
    }

    /**Quality refrence */
    fetchAllQualityReferences() {

        this.refLoading = true;
        this.qualityRef = [];
        this.sideNavService.fetchQualityRef(this.userId)
            .then((response: any) => {

                if (response &&
                    response.data.allQualityReferences &&
                    response.data.allQualityReferences.nodes) {

                    this.qualityRef = this.qualityRef.concat(response.data.allQualityReferences.nodes);

                    this.refDataSource = new MatTableDataSource(this.qualityRef);
                    this.refDataSource.paginator = this.refPaginator;
                    this.refDataSource.sort = this.refSort;

                }

                this.refLoading = false;

            })
            .catch(() => {
                this.refLoading = false;
            })
    }

    /**personality refrence */
    fetchAllPerReferences() {

        this.perLoading = true;

        this.personalityRef = [];

        this.sideNavService.fetchPersonalityRef(this.userId)
            .then((response: any) => {

                if (response &&
                    response.data.allPersonalityReferences &&
                    response.data.allPersonalityReferences.nodes) {

                    this.personalityRef = this.personalityRef.concat(response.data.allPersonalityReferences.nodes);

                    this.perDataSource = new MatTableDataSource(this.personalityRef);
                    this.perDataSource.paginator = this.perPaginator;
                    this.perDataSource.sort = this.perSort;
                }

                this.perLoading = false;

            })
            .catch(() => {
                this.perLoading = false;
            })
    }

}

export interface referenceData {
    name: string;
    email: string;
    phoneNumber: string;
    userId: string;
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/pro-reference/proReference.component.ts